export default __webpack_public_path__ + "static/media/sticker-O.1f3cb94f.png";